export interface SupApiEnvConfig {
  label: string;
  url: string;
  isProd: boolean;
}

export type SupApiEnv = "staging" | "dev" | "prod";
const configApi = () => {
  const allowedOrigins = (
    process.env.NEXT_PUBLIC_SF_API_ALLOWED_ORIGINS !== undefined ? process.env.NEXT_PUBLIC_SF_API_ALLOWED_ORIGINS.split(",") : ["staging", "dev", "prod"]
  ) as SupApiEnv[];
  return {
    cookieName: process.env.NEXT_PUBLIC_SF_API_COOKIE_NAME ?? "api-env",
    allowedOrigins,
    displayOrigin: process.env.NEXT_PUBLIC_SF_API_DISPLAY_ORIGIN === "true",
    switchAllowed: process.env.NEXT_PUBLIC_SF_API_SWITCH_ALLOWED === "true",
    defaultOrigin: (process.env.NEXT_PUBLIC_SF_API_DEFAULT_ORIGIN ?? "prod") as SupApiEnv,
    origins: {
      staging: {
        label: "Staging",
        url: "https://api-staging.superform.xyz/",
        isProd: false,
      },
      dev: {
        label: "Dev",
        url: "https://api-dev.superform.xyz/",
        isProd: false,
      },
      prod: {
        label: "Prod",
        url: "https://api.superform.xyz/",
        isProd: true,
      },
    } as Record<SupApiEnv, SupApiEnvConfig>,
  };
};

export default configApi();
